module.exports = __webpack_public_path__ + "static/media/img-location-taoyuan-en.b7a3aad0.svg";